import {useCallback} from "react";
import {Edge, Node, useReactFlow} from "@xyflow/react";
import { WorkflowNodeData } from "@/types/node";

export function useSelectedElements() {
  const {getNodes, getEdges, setNodes} = useReactFlow();

  const getSelectedNode = useCallback(() => {
    const nodes = getNodes();
    const selectedNode = nodes.find(node => node.selected === true) as Node<WorkflowNodeData> | null;
    return selectedNode ?? null;
  }, []);

  const getSelectedEdge = useCallback(() => {
    const edges = getEdges();
    return edges.find(edge => edge.selected === true) as Edge | null;
  }, [getEdges]);

  const setSelectedNode = useCallback((nodeId: string) => {
    setNodes(nodes =>
      nodes.map(n => ({
        ...n,
        selected: n.id === nodeId,
      }))
    );
  }, []);

  return {getSelectedNode, getSelectedEdge, setSelectedNode};
}
